import React, { useState } from 'react';
import { userApi } from '../../backend_urls/userApi';

const CreateManualEntry = () => {
    const [invoice, setInvoice] = useState({
        seller_name: "",
        seller_gstin: "",
        buyer_name: "",
        buyer_gstin: "",
        invoice_number: "",
        invoice_date: "",
        currency: "INR",
        grand_total: ""
    });

    const [lineItems, setLineItems] = useState([
        {
            description: "",
            hsn_sac: "",
            quantity: "",
            unit: "",
            rate: "",
            taxable_value: "",
            igst_amount: "",
            line_total: ""
        }
    ]);

    const handleChange = (e) => {
        setInvoice({ ...invoice, [e.target.name]: e.target.value });
    };

    const handleLineItemChange = (index, e) => {
        const updatedItems = [...lineItems];
        updatedItems[index][e.target.name] = e.target.value;
        setLineItems(updatedItems);
    };

    const addLineItem = () => {
        setLineItems([
            ...lineItems,
            {
                description: "",
                hsn_sac: "",
                quantity: "",
                unit: "",
                rate: "",
                taxable_value: "",
                igst_amount: "",
                line_total: ""
            }
        ]);
    };

    const removeLineItem = (index) => {
        const updated = [...lineItems];
        updated.splice(index, 1);
        setLineItems(updated);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const payload = { ...invoice, line_items: lineItems };
            await userApi.createManualInvoice(payload);
            alert("Invoice Created Successfully");
        } catch (error) {
            console.error(error);
            alert("Error creating invoice");
        }
    };

    return (
        <div style={{ padding: "30px" }}>
            <h1>Create Manual Invoice</h1>
            <form onSubmit={handleSubmit}>
                <h3>Seller Details</h3>
                <input
                    name="seller_name"
                    placeholder="Seller Name"
                    onChange={handleChange}
                />

                <input
                    name="seller_gstin"
                    placeholder="Seller GSTIN"
                    onChange={handleChange}
                />

                <h3>Buyer Details</h3>

                <input
                    name="buyer_name"
                    placeholder="Buyer Name"
                    onChange={handleChange}
                />

                <input
                    name="buyer_gstin"
                    placeholder="Buyer GSTIN"
                    onChange={handleChange}
                />

                <h3>Invoice Info</h3>

                <input
                    name="invoice_number"
                    placeholder="Invoice Number"
                    onChange={handleChange}
                />

                <input
                    type="date"
                    name="invoice_date"
                    onChange={handleChange}
                />

                <h3>Line Items</h3>

                {lineItems.map((item, index) => (
                    <div key={index} style={{ marginBottom: "10px" }}>

                        <input
                            name="description"
                            placeholder="Description"
                            onChange={(e) =>
                                handleLineItemChange(index, e)
                            }
                        />

                        <input
                            name="hsn_sac"
                            placeholder="HSN/SAC"
                            onChange={(e) =>
                                handleLineItemChange(index, e)
                            }
                        />

                        <input
                            name="quantity"
                            placeholder="Qty"
                            onChange={(e) =>
                                handleLineItemChange(index, e)
                            }
                        />

                        <input
                            name="unit"
                            placeholder="Unit"
                            onChange={(e) =>
                                handleLineItemChange(index, e)
                            }
                        />

                        <input
                            name="rate"
                            placeholder="Rate"
                            onChange={(e) =>
                                handleLineItemChange(index, e)
                            }
                        />

                        <input
                            name="taxable_value"
                            placeholder="Taxable Value"
                            onChange={(e) =>
                                handleLineItemChange(index, e)
                            }
                        />

                        <input
                            name="igst_amount"
                            placeholder="IGST"
                            onChange={(e) =>
                                handleLineItemChange(index, e)
                            }
                        />

                        <input
                            name="line_total"
                            placeholder="Total"
                            onChange={(e) =>
                                handleLineItemChange(index, e)
                            }
                        />

                        <button type="button" onClick={() => removeLineItem(index)}>
                            Remove
                        </button>
                    </div>
                ))}

                <button type="button" onClick={addLineItem}>Add Line Item</button>

                <h3>Total</h3>
                <input name="grand_total" placeholder="Grand Total" onChange={handleChange} />

                <br />
                <br />

                <button type="submit">Create Invoice</button>

            </form>
        </div>
    );
};

export default CreateManualEntry;
